import DataLayer from '../data'

export default ({ debug, eventbus, states, store, VueI18N }) => {
  debug && console.log('bootstrap.cp', 'init');
  store.dispatch('bootstrap/status', states.APPLICATION_AUTH);

  const dl = new DataLayer();

  eventbus.$on('logout', () => {
    console.log('logout the user please');
    dl.logout()
  });

  return new Promise((resolve) => {
    dl.bootstrapClientProject({ store })
      .then((config) => {
        VueI18N.setConfig(config.i18n);

        debug && console.log('bootstrap.cp', 'completed');
        return resolve();
      })
      .catch((error) => {
        debug && console.log('bootstrap.cp', 'error');
        console.log('cp reject', error);
      })
  })
}
